import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { showCaseApiURL } from 'Constants/Constants';
import axios from 'axios';

const initialState = {
  listAvaiabilityUnvaible: [],
  loading: false,
  loadingTimer: false,
  fetchTimerDailyOffer: {},
};

export const fetchTimerDailyOffer = createAsyncThunk(
  'showCase/fetchTimerDailyOffer',
  async (payload) => {
    const response = await axios.get(
      `${showCaseApiURL}/Showcase/DailyOffer/${payload.id}`,
      {
        headers: {
          campaignId: payload.campaignId,
          catalogId: payload.catalogId,
          participantId: payload.participantId,
          Authorization: `Bearer ${payload.access_token}`,
        },
      }
    );

    return response.data;
  }
);

const AutomateShowcaseSlice = createSlice({
  name: 'AutomateShowcaseSlice',
  initialState: initialState,
  reducers: {
    addAvaiabilityUnvaible: (state, action) => {
      state.listAvaiabilityUnvaible.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTimerDailyOffer.pending, (state) => {
        state.loadingTimer = true;
      })
      .addCase(fetchTimerDailyOffer.fulfilled, (state, action) => {
        state.loadingTimer = false;

        state.fetchTimerDailyOffer = action.payload;
      })
      .addCase(fetchTimerDailyOffer.rejected, (state) => {
        state.loadingTimer = false;
      });
  },
});
export const { addAvaiabilityUnvaible } = AutomateShowcaseSlice.actions;
export default AutomateShowcaseSlice.reducer;
